import style from './style.module.scss';
import { Select } from 'antd';
import { normalize } from '../../helpers/store-helper';

type ServiceOption = {
    label: string;
    value: string;
};

type DropDownServicesProps = {
    options: ServiceOption[];
    selectedOptions: string[];
    onChange?: (value: string[]) => void;
    placeholder?: string;
};

// Search has to match what the CMS user actually reads — the French service
// label — and not the underlying key (`essence-esso`)
const filterByLabel = (input: string, option?: ServiceOption) =>
    (normalize(option?.label) ?? '').includes(normalize(input) ?? '');

export const DropDownServices = ({
    options,
    selectedOptions,
    onChange,
    placeholder,
}: DropDownServicesProps) => {
    return (
        <Select
            mode="multiple"
            showArrow
            allowClear
            placeholder={placeholder}
            options={options}
            filterOption={filterByLabel}
            value={selectedOptions}
            onChange={onChange}
            className={style.services_select}
        />
    );
};
